import axios from 'axios';

export function stemParts(stem) {
  return String(stem || '').split('/').filter(Boolean);
}

export function allStems(pages) {
  const stems = new Set();
  pages.forEach((page) => {
    const parts = stemParts(page.stem);
    parts.forEach((_, i) => stems.add(parts.slice(0, i + 1).join('/')));
  });
  return [...stems].sort((a, b) => a.localeCompare(b));
}

export function childFolders(pages, parentStem) {
  const depth = stemParts(parentStem).length;
  return allStems(pages)
    .filter((stem) => stemParts(stem).length === depth + 1 && (!parentStem || stem.startsWith(`${parentStem}/`)))
    .map((stem) => ({ stem, name: stemParts(stem)[depth] }));
}

export function folderPages(pages, stem) {
  return pages
    .filter((page) => (page.stem || '') === (stem || ''))
    .sort((a, b) => a.title.localeCompare(b.title));
}

export function breadcrumb(stem) {
  const parts = stemParts(stem);
  return parts.map((name, i) => ({ name, stem: parts.slice(0, i + 1).join('/') }));
}

export function folderOptions(pages, excludeStem = '') {
  return allStems(pages)
    .filter((stem) => !excludeStem || (stem !== excludeStem && !stem.startsWith(`${excludeStem}/`)))
    .map((stem) => ({ stem, depth: stemParts(stem).length - 1, label: stemParts(stem).slice(-1)[0] }));
}

export function pageUrl(page) {
  return `/pages/${page.id}`;
}

export function folderUrl(stem) {
  const parts = stemParts(stem);
  return parts.length ? `/pages/folder/${parts.map(encodeURIComponent).join('/')}` : '/pages';
}

export function domainFolder(name) {
  return String(name || '').replace(/\//g, '-').trim().slice(0, 60);
}

export async function domainStems() {
  const { data } = await axios.get('/api/performancedomains/');
  return data.map((domain) => domainFolder(domain.name));
}
